import Buyabletest from './Models/Buyabletest'
import Cart from './Models/Cart'
import Invoice from './Models/Invoice'
import Item from './Models/Item'
import LocalShippingProvider from './Models/LocalShippingProvider'
import Order from './Models/Order'
import Payment from './Models/Payment'
import PaymentMethod from './Models/PaymentMethod'
import Shipping from './Models/Shipping'
import ShippingQuote from './Models/ShippingQuote'

Vue.prototype.$buyabletest = new Vue(Buyabletest)
Vue.prototype.$cart = new Vue(Cart)
Vue.prototype.$invoice = new Vue(Invoice)
Vue.prototype.$models.$item = new Vue(Item)
Vue.prototype.$models.$localShippingProvider = new Vue(LocalShippingProvider)
Vue.prototype.$models.$order = new Vue(Order)
Vue.prototype.$models.$payment = new Vue(Payment)
Vue.prototype.$models.$paymentMethod = new Vue(PaymentMethod)
Vue.prototype.$models.$shipping = new Vue(Shipping)
Vue.prototype.$models.$shippingQuote = new Vue(ShippingQuote)

app.$set(app.$state, 'cart', {})

if(app.$state.scope == 'web') {
	app.$cart.content()
}

Vue.component('cart-theme-example', () => import(/* webpackChunkName: "cart-theme-example" */ '@modulesPages/Ecommerce/Resources/assets/js/Cart/Themes/Example'))
Vue.component('cart-theme-totals', () => import(/* webpackChunkName: "cart-theme-totals" */ '@modulesPages/Ecommerce/Resources/assets/js/Cart/Themes/Totals'))
Vue.component('cart-theme-sidebar', () => import(/* webpackChunkName: "cart-theme-sidebar" */ '@modulesPages/Ecommerce/Resources/assets/js/Cart/Themes/Sidebar'))

Vue.component('orders-table', () => import(/* webpackChunkName: "orders-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/OrdersTable'))
Vue.component('items-table', () => import(/* webpackChunkName: "items-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/ItemsTable'))
Vue.component('buyabletests-table', () => import(/* webpackChunkName: "buyabletests-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/BuyabletestsTable'))
Vue.component('payments-table', () => import(/* webpackChunkName: "payments-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/PaymentsTable'))
Vue.component('payment-methods-table', () => import(/* webpackChunkName: "payment-methods-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/PaymentMethodsTable'))
Vue.component('shippings-table', () => import(/* webpackChunkName: "shippings-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/ShippingsTable'))
Vue.component('local-shipping-providers-table', () => import(/* webpackChunkName: "local-shipping-providers-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/LocalShippingProvidersTable'))
Vue.component('invoices-table', () => import(/* webpackChunkName: "invoices-table" */ '@modulesPages/Ecommerce/Resources/assets/js/Tables/InvoicesTable'))

Vue.component('orders-form', () => import(/* webpackChunkName: "orders-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Orders/OrdersForm'))
Vue.component('order-details', () => import(/* webpackChunkName: "order-details" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Orders/OrderDetails'))
Vue.component('items-form', () => import(/* webpackChunkName: "items-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Items/ItemsForm'))
Vue.component('item-details', () => import(/* webpackChunkName: "item-details" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Items/ItemDetails'))
Vue.component('buyabletests-form', () => import(/* webpackChunkName: "buyabletests-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Buyabletests/BuyabletestsForm'))
Vue.component('payments-form', () => import(/* webpackChunkName: "payments-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Payments/PaymentsForm'))
Vue.component('payment-details', () => import(/* webpackChunkName: "payment-details" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Payments/PaymentDetails'))
Vue.component('payment-methods-form', () => import(/* webpackChunkName: "payment-methods-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/PaymentMethods/PaymentMethodsForm'))
Vue.component('shippings-form', () => import(/* webpackChunkName: "shippings-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Shippings/ShippingsForm'))
Vue.component('shipping-details', () => import(/* webpackChunkName: "shipping-details" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Shippings/ShippingDetails'))
Vue.component('local-shipping-providers-form', () => import(/* webpackChunkName: "local-shipping-providers-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/LocalShippingProviders/LocalShippingProvidersForm'))
Vue.component('invoices-form', () => import(/* webpackChunkName: "invoices-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Invoices/InvoicesForm'))

Vue.component('local-deposit-web-payment-form', () => import(/* webpackChunkName: "local-deposit-web-payment-form" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Payments/Local/LocalDepositWebPaymentForm'))

Vue.component('buyables-card', () => import(/* webpackChunkName: "buyables-card" */ '@modulesPages/Ecommerce/Resources/assets/js/Cards/BuyablesCard'))

Vue.component('nav-item-dropdown-cart', () => import(/* webpackChunkName: "nav-item-dropdown-cart" */ '@modulesPages/Ecommerce/Resources/assets/js/Navbars/NavItemDropdownCart'))
Vue.component('nav-item-sidebar-cart', () => import(/* webpackChunkName: "nav-item-sidebar-cart" */ '@modulesPages/Ecommerce/Resources/assets/js/Navbars/NavItemSidebarCart'))

Vue.component('validate-rfc-button', () => import(/* webpackChunkName: "validate-rfc-button" */ '@modulesPages/Ecommerce/Resources/assets/js/Components/ValidateRFCButton'))



Vue.component('orders-form2', () => import(/* webpackChunkName: "orders-form2" */ '@modulesPages/Ecommerce/Resources/assets/js/Forms/Orders/OrdersForm2'))
Vue.component('items-card', () => import(/* webpackChunkName: "items-card" */ '@modulesPages/Ecommerce/Resources/assets/js/Cards/ItemsCard'))
Vue.component('orders-card', () => import(/* webpackChunkName: "orders-card" */ '@modulesPages/Ecommerce/Resources/assets/js/Cards/OrdersCard'))
Vue.component('addresses-card', () => import(/* webpackChunkName: "addresses-card" */ '@modulesPages/Ecommerce/Resources/assets/js/Cards/AddressesCard'))
Vue.component('address-card', () => import(/* webpackChunkName: "address-card" */ '@modulesPages/Ecommerce/Resources/assets/js/Cards/AddressCard'))
Vue.component('cart-theme-totals2', () => import(/* webpackChunkName: "cart-theme-totals2" */ '@modulesPages/Ecommerce/Resources/assets/js/Cart/Themes/Totals2'))


app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Ecommerce\\Entities\\Order': 'Pedido',
		'Modules\\Ecommerce\\Entities\\Item': 'Item de pedido',
		'Modules\\Ecommerce\\Entities\\Buyabletest': 'Artículo de prueba',
		'Modules\\Ecommerce\\Entities\\PaymentMethod': 'Métodos de pago',
		'Modules\\Ecommerce\\Entities\\LocalShippingProviders': 'Proveedor local de envío',
		'Modules\\Ecommerce\\Entities\\Invoice': 'Datos de facturación',
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Ecommerce\\Entities\\Order': 'orders',
        'Modules\\Ecommerce\\Entities\\Item': 'items',
        'Modules\\Ecommerce\\Entities\\Buyabletest': 'buyabletests',
		'Modules\\Ecommerce\\Entities\\PaymentMethod': 'payment-methods',
        'Modules\\Ecommerce\\Entities\\LocalShippingProvider': 'local-shipping-providers',
        'Modules\\Ecommerce\\Entities\\Invoice': 'invoices',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'orders': 'Modules\\Ecommerce\\Entities\\Order',
        'items': 'Modules\\Ecommerce\\Entities\\Item',
        'buyabletests': 'Modules\\Ecommerce\\Entities\\Buyabletest',
		'payment-methods': 'Modules\\Ecommerce\\Entities\\PaymentMethod',
        'local-shippings-providers': 'Modules\\Ecommerce\\Entities\\LocalShippingProvider',
        'invoices': 'Modules\\Ecommerce\\Entities\\Invoice',
	}	
}

app.$Util.formattedStatus = {
	...app.$Util.formattedStatus,
	...{
		'canceling': 'En proceso de cancelación',
        'canceled': 'Cancelado',
        'paying': 'En proceso de pagarse',
        'paid': 'Pagado',
        'accepted': 'Aceptado',
        'cancelled': 'Cancelado',
        'on way': 'En camino',
        'delivered': 'Entregado',
	}	
}

app.$Util.variantStatus = {
	...app.$Util.variantStatus,
	...{
		'accepted': 'success',
        'created': 'warning',
        'cancelled': 'danger',
        'promise': 'light'
	}	
}

app.$Util.formattedObjectKeyOrValue = {
	...app.$Util.formattedObjectKeyOrValue,
	...{
		deposit: 'Depósito',
		cash: 'Efectivo'
	}	
}

app.$Util.getFormattedInvoice = function(invoice, type = 'a') {
	let invoice_string = ' '

	switch(type) {
		case 'a':
			invoice_string = `${invoice.business_name} ${invoice.rfc}`
        break
	}

	return invoice_string
}

app.$root.$on('orders.statused', app.$cart.orderStatused)
app.$root.$on('orders.destroyed', app.$cart.orderDestroyed)
//app.$root.$on('shippings.statused', app.$cart.shippingStatused)
//app.$root.$on('payments.added', app.$cart.paymentAdded)